import dayjs from 'dayjs';
import { container, I18N_TOKEN } from '@/container';

export default function secondToTimeString(second: number) {
  if (second <= 0) return '';

  if (second <= 120) {
    return container.resolve(I18N_TOKEN).t('common.second', { count: second });
  }

  const minute = Math.floor(second / 60);
  if (minute < 60) {
    return container.resolve(I18N_TOKEN).t('common.minute', { count: minute });
  }

  const hour = Math.floor(minute / 60);
  if (hour <= 24) {
    return container.resolve(I18N_TOKEN).t('common.hour', { count: hour });
  }

  const day = Math.floor(hour / 24);
  return container.resolve(I18N_TOKEN).t('common.day', { count: day });
}

export function formatSecond(second: number) {
  const date = dayjs(second * 1000);
  return date.format('mm:ss');
}
